'use strict';

const TRIP_TYPES = {
    MULTI_SEGMENT: 'MULTI_SEGMENT',
    ROUND_TRIP: 'ROUND_TRIP',
    ONE_WAY: 'ONE_WAY',
};

const getSectionName = (section, tripType, segments) => {
    return tripType === TRIP_TYPES.ROUND_TRIP ? getSegmentNameOfSection(segments, section.id) : 'flight';
};

const getSegmentNameOfSection = (segments, sectionId) => {
    const sectionSegmentIndex = segments.findIndex((segment) => segment.sections.some((section) => section.id === sectionId));
    switch (sectionSegmentIndex) {
        case -1:
            return 'flight';
        case 0:
            return 'departure';
        default:
            return 'return';
    }
};

module.exports = {
    getSectionName,
};
